
    <ng-container>
      <mat-toolbar
        class="margin-top-0px"
        *ngIf="!isCreateCamera"
        color="primary"
      >
        <mat-toolbar-row class="subheader p-0">
          <form class="form col-xs-12 col-md-12 p-0">
            <div class="row">
              <div class="col-lg-4 col-md-4 col-sm-4 col-xs-4">

              </div>

              <div class="col-lg-4 col-md-4 col-sm-4 col-xs-4">

              </div>

              <div class="col-lg-4 col-md-4 col-sm-4 col-xs-4">


                <button
                  mat-raised-button
                  (click)="showcreateCamera('add', -1)"
                  class="btn btn-secondary example-icon floatright pl-3"
                  aria-label="Add a New Schools"
                >
                  <mat-icon class="a2z-maticon">add</mat-icon>
                  Add
                </button>
              </div>
            </div>
          </form>
        </mat-toolbar-row>
      </mat-toolbar>

      <div
        *ngIf="!isCreateCamera"
        class="table-responsive"
      >
        <table
          mat-table
          [dataSource]="cameradataSource"
          class="mat-elevation-z1"
          matSort
          (matSortChange)="applySort($event)"
        >
          <!--- Note that these columns can be defined in any order.
                     The actual rendered columns are set as a property on the row definition" -->

          <ng-container matColumnDef="id">
            <th mat-header-cell *matHeaderCellDef>No.</th>
            <td
              mat-cell
              *matCellDef="let element; let i = index"
              class="font-size-lg mb-0"
            >
              {{ i + 1 + Page_Size * (Page_Index - 1) }}
            </td>
          </ng-container>

          <ng-container matColumnDef="ip_address">
            <th mat-header-cell *matHeaderCellDef>IP Address</th>
            <td
              mat-cell
              *matCellDef="let element"
              class="font-size-lg mb-0 text-capitalize"
            >
              {{ element.camera_ip }}
              <br>
              <span class="text-secondary">{{ element.camera_ip_type }}</span>
            </td>
          </ng-container>

          <ng-container matColumnDef="camera">
            <th mat-header-cell *matHeaderCellDef>Camera Name</th>
            <td
              mat-cell
              *matCellDef="let element"
              class="font-size-lg mb-0 text-capitalize"
            >
              {{ element.camera_name }}
            </td>
          </ng-container>


          <ng-container matColumnDef="type">
            <th mat-header-cell *matHeaderCellDef>Camera Type</th>
            <td mat-cell *matCellDef="let element" class="font-size-lg mb-0">
              {{ element.camera_short_name | uppercase }}
            </td>
          </ng-container>

          <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef class="textaligncenter">
              Actions
            </th>
            <td mat-cell *matCellDef="let element">
              <div class="text-center" >
                <button
                *ngIf="element.consult_id == null"
                  mat-icon-button
                  class="btn btn-sm btn-default btn-text-primary btn-icon mr-2"
                  color="primary"
                  (click)="showcreateCamera('update', element.id)"
                  [disabled]="element.freeze == 1"
                >
                  <span class="svg-icon svg-icon-md" [class]="element.freeze==1?' svg-icon-dark':' svg-icon-dfprimary'">
                    <span [inlineSVG]="editicon"></span>
                  </span>
                </button>
                <button
                *ngIf="element.consult_id == null"
                  mat-icon-button
                  class="btn btn-sm btn-default btn-text-secondary btn-icon mr-2"
                  color="secondary"
                  (click)="deleteCamera(element.id)"
                >
                  <span class="svg-icon svg-icon-md svg-icon-secondary">
                    <span [inlineSVG]="deleteicon"></span>
                  </span>
                </button>
                <span matTooltip="Updated by Doctor" *ngIf="element.consult_id != null">
                  <span class="material-icons">
                    warning_amber
                    </span>
                </span>
              </div>
            </td>
          </ng-container>

          <tr
            mat-header-row
            *matHeaderRowDef="camera_displayedColumns"
          ></tr>
          <tr
            mat-row
            *matRowDef="let row; columns: camera_displayedColumns"
          ></tr>
        </table>



    <ng-container *ngIf="cameradataSource.data.length < 1">
      <h4 class="text-center bg-white m-0">There is no data</h4>
    </ng-container>


        <mat-paginator
          [length]="totalLength"
          [pageSize]="Page_Size"
          [showFirstLastButtons]="true"
          [pageSizeOptions]="PageSize_Options"
          (page)="LoadData($event)"
        >
        </mat-paginator>
      </div>


    </ng-container>

    <school-camera-form
      *ngIf="isCreateCamera"
      [formtype]="FormStatus"
      [cameraId]="cameraId"
      (cancelEvent)="showCameralist()"
    >
    </school-camera-form>
